import { IProductDefinitionList,NodeObjectRepository } from '@/models/assembly';
import { GordionKesonlu } from './defs/gordion-kesonlu';
import { GordionToplanti } from './defs/gordion-toplanti';
import { GordionSehpa } from './defs/gordion-sehpa';
import { BasicToplanti } from '@/models/assembly/defs/basic-toplanti';
import { ApsisMasa } from '@/models/assembly/defs/apsis-masa';
import { ApsisMasaEtajerli } from '@/models/assembly/defs/apsis-masa-etajerli';
import { ApsisYanTabanliMasa } from '@/models/assembly/defs/apsis-yan-tabanli-masa';
import { ApsisToplantiMasa } from '@/models/assembly/defs/apsis-toplanti-masa';
import { Reflex } from '@/models/assembly/defs/reflex';
export const ProductDefinitions: IProductDefinitionList = {
  ...GordionKesonlu,
  ...GordionToplanti,
  ...GordionSehpa,
  ...BasicToplanti,
  ...ApsisMasa,
  ...ApsisMasaEtajerli,
  ...ApsisYanTabanliMasa,
  ...ApsisToplantiMasa,
  ...Reflex,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/models/assembly/data.ts